<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="globe"/>
          {{ $t('partnerDomain.title') }}
        </h1>
      </div>
    </div>
    <partner-domain-list></partner-domain-list>
  </main>
</template>

<script>
import PartnerDomainList from "@/views/partner-domain/PartnerDomainList.vue";

export default {
  components: { PartnerDomainList },
  i18n: {
    messages: {
      en: { partnerDomain: { title: 'Partner domains' } },
      vi: { partnerDomain: { title: 'Domain đối tác' } }
    }
  }
}
</script>
